export default {
  methods: {
    initRefList: function initRefList() {
      if (this.refList !== null && !!this.widget.options.name) {
        this.refList[this.widget.options.name] = this;
      }
    },
    getWidgetRef: function getWidgetRef(widgetName) {
      var showError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var foundRef = this.refList[widgetName];
      if (!foundRef && !!showError) {
        this.$message.error(this.i18nt('render.hint.refNotFound') + widgetName);
      }
      return foundRef;
    },
    /* 该方法用于组件重名检查！！ */registerToRefList: function registerToRefList(oldRefName) {
      if (this.refList !== null && !!this.widget.options.name) {
        if (!!oldRefName) {
          delete this.refList[oldRefName];
        }
        this.refList[this.widget.options.name] = this;
      }
    }
  }
};